import { useState, useCallback } from 'react';
import { get, put } from '../../utils/networkUtils';

export const useLeaderboard = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Get leaderboard for a pickem
  const fetchPickemLeaderboard = useCallback(async (pickemId, offset = 0, limit = 100) => {
    setLoading(true);
    setError(null);
    try {
      const response = await get(`/admin/pickem-leaderboard/${pickemId}?offset=${offset}&limit=${limit}`);
      return response;
    } catch (err) {
      setError(err.message || 'Failed to fetch leaderboard');
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  // Get leaderboard for a tournament
  const fetchTournamentLeaderboard = useCallback(async (tournamentId, offset = 0, limit = 100) => {
    setLoading(true);
    setError(null);
    try {
      const response = await get(`/admin/tournament-leaderboard/${tournamentId}?offset=${offset}&limit=${limit}`);
      return response;
    } catch (err) {
      setError(err.message || 'Failed to fetch tournament leaderboard');
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  // Get leaderboard for a league
  const fetchLeagueLeaderboard = useCallback(async (leagueId, offset = 0, limit = 100) => {
    setLoading(true);
    setError(null);
    try {
      const response = await get(`/admin/league-leaderboard/${leagueId}?offset=${offset}&limit=${limit}`);
      return response;
    } catch (err) {
      setError(err.message || 'Failed to fetch league leaderboard');
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  // Update pinned users in leaderboard
  const updatePinnedUsers = useCallback(async (pickemId, pinUserIds) => {
    setLoading(true);
    setError(null);
    try {
      const response = await put(`/admin/pickem-leaderboard/${pickemId}`, { pinUserIds });
      return response;
    } catch (err) {
      setError(err.message || 'Failed to update pinned users');
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  // Export leaderboard as CSV
  const exportLeaderboardCsv = useCallback(async (pickemId) => {
    setLoading(true);
    setError(null);
    try {
      const response = await get(`/admin/pickem-leaderboard/${pickemId}/csv`, { 
        responseType: 'blob' 
      });
      return response;
    } catch (err) {
      setError(err.message || 'Failed to export leaderboard');
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    loading,
    error,
    fetchPickemLeaderboard,
    fetchTournamentLeaderboard,
    fetchLeagueLeaderboard,
    updatePinnedUsers,
    exportLeaderboardCsv,
  };
};
